export default "__VITE_ASSET__B4sHJh79__"